import React, { FC } from 'react';
import { FieldProps, useFieldValue } from 'react-admin';
import Checkbox from '@mui/material/Checkbox';

interface CheckValueFieldProps extends FieldProps {
    checkedValue: string;
}

const CheckValueField: FC<CheckValueFieldProps> = (props: CheckValueFieldProps) => {
    const { checkedValue, source } = props;
    const value = useFieldValue(props)
    const isChecked = value === checkedValue;

    return (
        <Checkbox
            checked={isChecked}
            disabled
            // Optionally, you can remove the tab stop for a read-only field
            tabIndex={-1}
            // Optionally, add an aria-label for accessibility:
            inputProps={{ 'aria-label': `${source} ${isChecked ? 'checked' : 'unchecked'}` }}
        />
    );
};

export default CheckValueField;
